var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktopDevice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95352 17H2.75C1.7835 17 1 16.2165 1 15.25V3.75C1 2.7835 1.7835 2 2.75 2H21.25C22.2165 2 23 2.7835 23 3.75V15.25C23 16.2165 22.2165 17 21.25 17H15.0463C15.217 18.3751 15.8509 19.6522 16.815 20.7568C17.0083 20.9784 17.0544 21.2926 16.9327 21.5604C16.811 21.8281 16.544 22 16.2499 22H7.74989C7.45578 22 7.18882 21.8281 7.06711 21.5604C6.94541 21.2926 6.99144 20.9784 7.18482 20.7568C8.14891 19.6522 8.78282 18.3751 8.95352 17ZM21.5 3.75V15.25C21.5 15.3881 21.3881 15.5 21.25 15.5H2.75C2.61193 15.5 2.5 15.3881 2.5 15.25V3.75C2.5 3.61193 2.61193 3.5 2.75 3.5H21.25C21.3881 3.5 21.5 3.61193 21.5 3.75ZM13.5369 17C13.6624 18.2662 14.1009 19.445 14.7601 20.5H9.23971C9.89885 19.445 10.3373 18.2662 10.4629 17H13.5369Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopDevice);
export default __webpack_public_path__ + "static/media/desktop-device.10b97150.svg";
export { ForwardRef as ReactComponent };